import type { CountryCapability } from "../../utils/catalogCountries";
import { SelectCountrySlot } from "./SelectCountrySlot";

export interface SelectDestinationCountrySlotProps {
  countries: CountryCapability[];
  selected?: string | null;
  onSelect: (countryCode: string) => void;
  onClose: () => void;
  ns?: string;
}

export const SelectDestinationCountrySlot: React.FC<
  SelectDestinationCountrySlotProps
> = (props) => (
  <SelectCountrySlot titleKey="transfer.selectDestination" {...props} />
);
